import { render, staticRenderFns } from "./ServiceTodayNumber.vue?vue&type=template&id=55a39634&scoped=true&"
import script from "./ServiceTodayNumber.vue?vue&type=script&lang=js&"
export * from "./ServiceTodayNumber.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTodayNumber.vue?vue&type=style&index=0&id=55a39634&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a39634",
  null
  
)

export default component.exports